import axios from "axios";
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";
// import {loginData} from "../features/login";
// import secureLocalStorage from "redux-persist/es/storage/session";
import secureLocalStorage from 'react-secure-storage'
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)


const baseURL   = "http://remote.amesrl.it/php/new-query.php";
const refreshURL = "http://remote.amesrl.it/php/refresh.php";


let token  = -1;
let refToken  = -1;
let port = -1;

const axiosIstance = axios.create({
    baseURL,
    headers:{'Authorization' : '' + token}
});

axiosIstance.interceptors.request.use(async req => {
    //console.log("Interceptor");
    
    // store.getState().login.value.token ? token = store.getState().login.value.token :  token = "";
    // store.getState().login.value.refToken ? refToken = store.getState().login.value.refToken :  refToken = "";
    // store.getState().login.value.port ? port = store.getState().login.value.port :  port = "";

    token = secureLocalStorage.getItem('token') ? secureLocalStorage.getItem('token') : -1;
    refToken = secureLocalStorage.getItem('refToken') ? secureLocalStorage.getItem('refToken') : -1;
    port = secureLocalStorage.getItem('port') ? secureLocalStorage.getItem('port') : -1;

    if(req === undefined){
        return;
    }

   

    if(token != -1){
        
        //console.log(token)
        console.log( req.headers);
        req.headers.Authorization = '' + token;
        const user = jwt_decode(token);
        const isExp = dayjs.unix(user.exp).diff(dayjs.utc()) < 1;
        // console.log("Token: ");
        // console.log(user);
        // console.log( dayjs.unix(user.exp).diff(dayjs.utc()));
        // console.log( (dayjs()));

        const _refToken = jwt_decode(refToken);
        const isExprefToken = dayjs.unix(_refToken.exp).diff(dayjs.utc()) < 1;
        // console.log("------------> refToken: ", _refToken,isExprefToken, dayjs.unix(isExprefToken.exp).diff(dayjs.utc()));
        console.log(req);
        if(!isExp) return req;
        else console.log("Token expired");

        let jwtRefresh = refToken;
        const _jwtRefresh = jwt_decode(refToken);
        const isExprefTokenjwtRefresh = dayjs.unix(_jwtRefresh.exp);

        // console.log("------------> isExprefTokenjwtRefresh: ", isExprefTokenjwtRefresh)


        // let id = user.data.idC;
        // let descr = user.data.descr;

        // console.log(descr);
        // console.log(id);
        
        const userRef = jwt_decode(token);
        const isExpRef = dayjs.unix(userRef.exp).diff(dayjs.utc()) < 1;
        
        if(!isExpRef || jwtRefresh == '' || jwtRefresh == undefined){
            console.log("------------> clear secure storage --------------------  ");
            secureLocalStorage.clear();
            return;
        }

        var form = new FormData();
        form.append('jwt', jwtRefresh);   

        req =  await axios.post(refreshURL, {'jwt': jwtRefresh })
        .then(response =>{

            if(response.status === 200){
                if(response.data.jwt){
                    token = response.data.jwt;
                    // store.dispatch(loginData({'token': token, refToken: refToken}));
                    secureLocalStorage.setItem('token', response.data.jwt);
                    secureLocalStorage.setItem('refToken', refToken);
                    return req;
                }
            }else{
            
                secureLocalStorage.setItem('token', undefined);
                secureLocalStorage.setItem('refToken', undefined);
                // store.dispatch(loginData({'token': -1, refToken: -1}));
                return;
            }
        })
        .catch(
        error => {
            secureLocalStorage.setItem('token', undefined);
            secureLocalStorage.setItem('refToken', undefined);
            // store.dispatch(loginData({'token': -1, refToken: -1}));
            return;
        })

        //console.log(req);
        req.headers.Authorization = '' + token;
        console.log(req);
        return req;
    }else{
        return;
    }
})


export default axiosIstance;